// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/bde6c351270a46ab6814.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"e169e35fcd97c6ddaed5","136":"e152992af0a32b3ed8ad","137":"4de2dd70af79fc298c90"}[chunkId] + ".chunk.js";
};